import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from 'underscore';
import { CompoundButton } from '@fluentui/react';
import { registerIcons } from '@fluentui/style-utilities';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import BrowseImg from '../../media/browse.svg';
import CreateImg from '../../media/create.svg';
import { getAudienceActionsStyle } from '../styles/audience-actions';

registerIcons({
  icons: {
    BrowseAudienceSignal: (
      <img src={BrowseImg} alt="Browse existing" />
    ),
    CreateAudienceSignal: (
      <img src={CreateImg} alt="Create" />
    ),
  },
});

const UnstyledAudienceActions = (props) => {
  const {
    classes,
    i18n,
    onBrowseAudienceSignal,
    onCreateAudienceSignal,
  } = props;

  return (
    <div className={classNames(['audience-actions', classes.actionsContainer])}>
      <div className="audience-actions-body">
        <CompoundButton
          className="btn-create-audience-signal"
          iconProps={{ iconName: 'CreateAudienceSignal' }}
          secondaryText={i18n.getString(_TL_('I have a new group of potential customers in mind.'))}
          onClick={() => onCreateAudienceSignal()}
        >
          {i18n.getString(_TL_('Create'))}
        </CompoundButton>
        <CompoundButton
          className="btn-browse-audience-signal"
          iconProps={{ iconName: 'BrowseAudienceSignal' }}
          secondaryText={i18n.getString(_TL_('Add an existing audience signal.'))}
          onClick={() => onBrowseAudienceSignal()}
        >
          {i18n.getString(_TL_('Browse'))}
        </CompoundButton>
      </div>
    </div>
  );
};

UnstyledAudienceActions.propTypes = {
  classes: PropTypes.shape({
    actionsContainer: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onBrowseAudienceSignal: PropTypes.func,
  onCreateAudienceSignal: PropTypes.func,
};

UnstyledAudienceActions.defaultProps = {
  onBrowseAudienceSignal: noop,
  onCreateAudienceSignal: noop,
};

export const AudienceActions = withDefaultStyles(UnstyledAudienceActions, getAudienceActionsStyle);
